export const i18nEPG = {
  es: {
    creditcards: {
      cardholdername: 'Titular de la tarjeta',
      cardnumber: 'Número de tarjeta de crédito/débito',
      cvv: 'CVC',
      expirationdate: 'Caducidad',
      cardtype: 'Tipo de tarjeta de crédito/débito',
      placeholderdate: 'MM / AA'
    },
    validationError: {
      numbersOnly: 'Solo dígitos',
      dateFormat: 'Formato de fecha MMAA',
      minSize: 'Tamaño mínimo {0}',
      maxSize: 'Tamaño máximo {0}',
      luhnCheck: 'El campo no es válido según el Algoritmo de Luhn',
      latinCharacters: "Introduzca solo carácteres latinos, espacio, coma, . ' o -",
      invalidExpDate: 'Fecha de caducidad no válida (MMAA)',
      expiredExpDate: 'La fecha ha expirado',
      requiredField: 'El campo es requerido'
    }
  },
  al: {
    creditcards: {
      cardholdername: 'Karteninhaber',
      cardnumber: 'Kredit-/ Debitkartennummer',
      cvv: 'CVC',
      expirationdate: 'Ablauf',
      cardtype: 'Kredit-/ Debitkartentyp',
      placeholderdate: 'MM / JJ'
    },
    validationError: {
      cvnLength: 'Wrong CVN length for this card type',
      dateFormat: 'Date format MMYY',
      luhnCheck: 'Field is not a valid number according to Luhn Algorithm',
      maxSize: 'Max size {0}',
      minSize: 'Min size {0}',
      numbersOnly: 'Numbers only',
      requiredField: 'Required field',
      latinCharacters: "Please use only latin letters, whitespace, comma, . ' or -",
      expiredExpDate: 'The expiry date you provided has already expired',
      invalidExpDate: 'Expiry date provided is invalid (MMYY)'
    }
  },
  ca: {
    creditcards: {
      cardholdername: 'Titular de la targeta',
      cardnumber: 'Número de la targeta de crèdit o dèbit',
      cvv: 'CVC',
      expirationdate: 'Caducitat',
      cardtype: 'Tipus de targeta de crèdit o dèbit',
      placeholderdate: 'MM / AA'
    },
    validationError: {
      cvnLength: 'Wrong CVN length for this card type',
      dateFormat: 'Date format MMYY',
      luhnCheck: 'Field is not a valid number according to Luhn Algorithm',
      maxSize: 'Max size {0}',
      minSize: 'Min size {0}',
      numbersOnly: 'Numbers only',
      requiredField: 'Required field',
      latinCharacters: "Please use only latin letters, whitespace, comma, . ' or -",
      expiredExpDate: 'The expiry date you provided has already expired',
      invalidExpDate: 'Expiry date provided is invalid (MMYY)'
    }
  },
  cn: {
    creditcards: {
      cardholdername: '信用卡持卡人',
      cardnumber: '信用卡/借记卡卡号',
      cvv: 'CVC',
      expirationdate: '过期',
      cardtype: '信用卡/借记卡类型',
      placeholderdate: 'MM / YY'
    },
    validationError: {
      cvnLength: 'Wrong CVN length for this card type',
      dateFormat: 'Date format MMYY',
      luhnCheck: 'Field is not a valid number according to Luhn Algorithm',
      maxSize: 'Max size {0}',
      minSize: 'Min size {0}',
      numbersOnly: 'Numbers only',
      requiredField: 'Required field',
      latinCharacters: "Please use only latin letters, whitespace, comma, . ' or -",
      expiredExpDate: 'The expiry date you provided has already expired',
      invalidExpDate: 'Expiry date provided is invalid (MMYY)'
    }
  },
  cz: {
    creditcards: {
      cardholdername: 'Jméno majitele karty',
      cardnumber: 'Číslo kreditní/debetní karty',
      cvv: 'CVC',
      expirationdate: 'Datum konce platnosti karty',
      cardtype: 'Typ kreditní/debetní karty',
      placeholderdate: 'MM / RR'
    },
    validationError: {
      cvnLength: 'Wrong CVN length for this card type',
      dateFormat: 'Date format MMYY',
      luhnCheck: 'Field is not a valid number according to Luhn Algorithm',
      maxSize: 'Max size {0}',
      minSize: 'Min size {0}',
      numbersOnly: 'Numbers only',
      requiredField: 'Required field',
      latinCharacters: "Please use only latin letters, whitespace, comma, . ' or -",
      expiredExpDate: 'The expiry date you provided has already expired',
      invalidExpDate: 'Expiry date provided is invalid (MMYY)'
    }
  },
  en: {
    creditcards: {
      cardholdername: 'Cardholder',
      cardnumber: 'Credit/debit card number',
      cvv: 'CVC',
      expirationdate: 'Expiration',
      cardtype: 'Credit/debit card type',
      placeholderdate: 'MM / YY'
    },
    validationError: {
      cvnLength: 'Wrong CVN length for this card type',
      dateFormat: 'Date format MMYY',
      luhnCheck: 'Field is not a valid number according to Luhn Algorithm',
      maxSize: 'Max size {0}',
      minSize: 'Min size {0}',
      numbersOnly: 'Numbers only',
      requiredField: 'Required field',
      latinCharacters: "Please use only latin letters, whitespace, comma, . ' or -",
      expiredExpDate: 'The expiry date you provided has already expired',
      invalidExpDate: 'Expiry date provided is invalid (MMYY)'
    }
  },
  fr: {
    creditcards: {
      cardholdername: 'Titulaire de la carte',
      cardnumber: 'Numéro de carte de crédit/débit',
      cvv: 'CVC',
      expirationdate: 'Expiration',
      cardtype: 'Type de carte de crédit/débit',
      placeholderdate: 'MM / AA'
    },
    validationError: {
      cvnLength: 'Wrong CVN length for this card type',
      dateFormat: 'Date format MMYY',
      luhnCheck: 'Field is not a valid number according to Luhn Algorithm',
      maxSize: 'Max size {0}',
      minSize: 'Min size {0}',
      numbersOnly: 'Numbers only',
      requiredField: 'Required field',
      latinCharacters: "Please use only latin letters, whitespace, comma, . ' or -",
      expiredExpDate: 'The expiry date you provided has already expired',
      invalidExpDate: 'Expiry date provided is invalid (MMYY)'
    }
  },
  hu: {
    creditcards: {
      cardholdername: 'Cardholder',
      cardnumber: 'Hitel-/debitkártya száma',
      cvv: 'CVC',
      expirationdate: 'Expiration',
      cardtype: 'Hitel-/debitkártya típusa',
      placeholderdate: 'MM / YY'
    },
    validationError: {
      cvnLength: 'Wrong CVN length for this card type',
      dateFormat: 'Date format MMYY',
      luhnCheck: 'Field is not a valid number according to Luhn Algorithm',
      maxSize: 'Max size {0}',
      minSize: 'Min size {0}',
      numbersOnly: 'Numbers only',
      requiredField: 'Required field',
      latinCharacters: "Please use only latin letters, whitespace, comma, . ' or -",
      expiredExpDate: 'The expiry date you provided has already expired',
      invalidExpDate: 'Expiry date provided is invalid (MMYY)'
    }
  },
  it: {
    creditcards: {
      cardholdername: 'Titolare della carta',
      cardnumber: 'Numero della carta di credito/debito',
      cvv: 'CVC',
      expirationdate: 'Scadenza',
      cardtype: 'Tipo di carta di credito/debito',
      placeholderdate: 'HH / EE'
    },
    validationError: {
      cvnLength: 'Wrong CVN length for this card type',
      dateFormat: 'Date format MMYY',
      luhnCheck: 'Field is not a valid number according to Luhn Algorithm',
      maxSize: 'Max size {0}',
      minSize: 'Min size {0}',
      numbersOnly: 'Numbers only',
      requiredField: 'Required field',
      latinCharacters: "Please use only latin letters, whitespace, comma, . ' or -",
      expiredExpDate: 'The expiry date you provided has already expired',
      invalidExpDate: 'Expiry date provided is invalid (MMYY)'
    }
  },
  nl: {
    creditcards: {
      cardholdername: 'Kaartbeheerder',
      cardnumber: 'Credit-/debitcardnummer',
      cvv: 'CVC',
      expirationdate: 'Vervaldatum',
      cardtype: 'Credit-/debitcardtype',
      placeholderdate: 'MM / JJ'
    },
    validationError: {
      cvnLength: 'Wrong CVN length for this card type',
      dateFormat: 'Date format MMYY',
      luhnCheck: 'Field is not a valid number according to Luhn Algorithm',
      maxSize: 'Max size {0}',
      minSize: 'Min size {0}',
      numbersOnly: 'Numbers only',
      requiredField: 'Required field',
      latinCharacters: "Please use only latin letters, whitespace, comma, . ' or -",
      expiredExpDate: 'The expiry date you provided has already expired',
      invalidExpDate: 'Expiry date provided is invalid (MMYY)'
    }
  },
  pl: {
    creditcards: {
      cardholdername: 'Cardholder',
      cardnumber: 'Card number',
      cvv: 'CVC',
      expirationdate: 'Expiration',
      cardtype: 'Card type',
      placeholderdate: 'MM / RR'
    },
    validationError: {
      cvnLength: 'Wrong CVN length for this card type',
      dateFormat: 'Date format MMYY',
      luhnCheck: 'Field is not a valid number according to Luhn Algorithm',
      maxSize: 'Max size {0}',
      minSize: 'Min size {0}',
      numbersOnly: 'Numbers only',
      requiredField: 'Required field',
      latinCharacters: "Please use only latin letters, whitespace, comma, . ' or -",
      expiredExpDate: 'The expiry date you provided has already expired',
      invalidExpDate: 'Expiry date provided is invalid (MMYY)'
    }
  },
  pt: {
    creditcards: {
      cardholdername: 'Titular do cartão',
      cardnumber: 'Número de cartão de débito/crédito',
      cvv: 'CVC',
      expirationdate: 'Caducidade',
      cardtype: 'Tipo de cartão de débito/crédito',
      placeholderdate: 'MM / AA'
    },
    validationError: {
      cvnLength: 'Wrong CVN length for this card type',
      dateFormat: 'Date format MMYY',
      luhnCheck: 'Field is not a valid number according to Luhn Algorithm',
      maxSize: 'Max size {0}',
      minSize: 'Min size {0}',
      numbersOnly: 'Numbers only',
      requiredField: 'Required field',
      latinCharacters: "Please use only latin letters, whitespace, comma, . ' or -",
      expiredExpDate: 'The expiry date you provided has already expired',
      invalidExpDate: 'Expiry date provided is invalid (MMYY)'
    }
  },
  ru: {
    creditcards: {
      cardholdername: 'Владелец карточки',
      cardnumber: 'Номер кредитной или дебетовой карты',
      cvv: 'CVC',
      expirationdate: 'Окончание срока действия',
      cardtype: 'Тип кредитной или дебетовой карты',
      placeholderdate: 'мм / гг'
    },
    validationError: {
      cvnLength: 'Wrong CVN length for this card type',
      dateFormat: 'Date format MMYY',
      luhnCheck: 'Field is not a valid number according to Luhn Algorithm',
      maxSize: 'Max size {0}',
      minSize: 'Min size {0}',
      numbersOnly: 'Numbers only',
      requiredField: 'Required field',
      latinCharacters: "Please use only latin letters, whitespace, comma, . ' or -",
      expiredExpDate: 'The expiry date you provided has already expired',
      invalidExpDate: 'Expiry date provided is invalid (MMYY)'
    }
  },
  sk: {
    creditcards: {
      cardholdername: 'Cardholder',
      cardnumber: 'Credit/debit card number',
      cvv: 'CVC',
      expirationdate: 'Vypršala',
      cardtype: 'Credit/debit card type',
      placeholderdate: 'MM / YY'
    },
    validationError: {
      cvnLength: 'Wrong CVN length for this card type',
      dateFormat: 'Date format MMYY',
      luhnCheck: 'Field is not a valid number according to Luhn Algorithm',
      maxSize: 'Max size {0}',
      minSize: 'Min size {0}',
      numbersOnly: 'Numbers only',
      requiredField: 'Required field',
      latinCharacters: "Please use only latin letters, whitespace, comma, . ' or -",
      expiredExpDate: 'The expiry date you provided has already expired',
      invalidExpDate: 'Expiry date provided is invalid (MMYY)'
    }
  },
  zf: {
    creditcards: {
      cardholdername: 'Titulaire de la carte',
      cardnumber: 'Credit/debit card number',
      cvv: 'CVC',
      expirationdate: 'Expiration',
      cardtype: 'Credit/debit card type',
      placeholderdate: 'MM / YY'
    },
    validationError: {
      cvnLength: 'Wrong CVN length for this card type',
      dateFormat: 'Date format MMYY',
      luhnCheck: 'Field is not a valid number according to Luhn Algorithm',
      maxSize: 'Max size {0}',
      minSize: 'Min size {0}',
      numbersOnly: 'Numbers only',
      requiredField: 'Required field',
      latinCharacters: "Please use only latin letters, whitespace, comma, . ' or -",
      expiredExpDate: 'The expiry date you provided has already expired',
      invalidExpDate: 'Expiry date provided is invalid (MMYY)'
    }
  },
  ar: {
    creditcards: {
      cardholdername: 'صاحب البطاقة',
      cardnumber: 'رقم بطاقة الائتمان / الخصم',
      cvv: 'CVC',
      expirationdate: 'انتهاء الصلاحية',
      cardtype: 'نوع بطاقة الائتمان / الخصم',
      placeholderdate: 'MM / YY'
    },
    validationError: {
      cvnLength: 'Wrong CVN length for this card type',
      dateFormat: 'Date format MMYY',
      luhnCheck: 'Field is not a valid number according to Luhn Algorithm',
      maxSize: 'Max size {0}',
      minSize: 'Min size {0}',
      numbersOnly: 'Numbers only',
      requiredField: 'Required field',
      latinCharacters: "Please use only latin letters, whitespace, comma, . ' or -",
      expiredExpDate: 'The expiry date you provided has already expired',
      invalidExpDate: 'Expiry date provided is invalid (MMYY)'
    }
  }
};
